import ApiResourceManager from '../ApiResourceManager';

export default class PromotionsManager extends ApiResourceManager {
  getCashbackProgram = () =>
    this.request({
      method: 'GET',
      url: '/cashback-program',
    });

  updateCashbackProgram = (data) =>
    this.request({
      method: 'PUT',
      url: '/cashback-program',
      data,
    });

  updateCashbackProgramStatus = (data) =>
    this.request({
      method: 'PUT',
      url: '/cashback-program/status',
      data,
    });

  uploadCashbackBonusImage = (bonusType, data) =>
    this.request({
      method: 'POST',
      url: `/cashback-program/bonus-images/${bonusType}`,
      data,
    });

  deleteCashbackBonusImage = (bonusType) =>
    this.request({
      method: 'DELETE',
      url: `/cashback-program/bonus-images/${bonusType}`,
    });

  generateCashbackBonusImage = (bonusType) =>
    this.request({
      method: 'POST',
      url: `/cashback-program/bonus-images/${bonusType}/generate`,
    });

  getGoogleReviewProgram = () =>
    this.request({
      method: 'GET',
      url: '/google-review-program',
    });

  updateGoogleReviewProgram = (data) =>
    this.request({
      method: 'PUT',
      url: '/google-review-program',
      data,
    });
}
